/* eslint-disable @typescript-eslint/no-explicit-any */ import React, { useMemo } from 'react';
import { icons } from '@tapresearch/ui/components';
import { useDisclosure } from '@tapresearch/ui/hooks';
import { ActivatePlayerInsightsModal } from './ActivatePlayerInsightsModal';
import { SUPPLIER_STATUS_ACTIVE } from '../../supplier_dashboard/util/constants';
export var useSidebarNav = function(props) {
    return useMemo(function() {
        var _user_organization, _user_organization_membership;
        var constants = props.constants, user = props.user, onNavigate = props.onNavigate, isLinkActive = props.isLinkActive, internal = props.internal, piActivation = props.piActivation, _props_isInactivePublisher = props.isInactivePublisher, isInactivePublisher = _props_isInactivePublisher === void 0 ? false : _props_isInactivePublisher;
        var is_active = (user && user.organization_membership || {}).is_active;
        var _ref = user && user.organization || {}, supplier = _ref.supplier, customer = _ref.customer;
        var isSupplierDashboard = internal === 'supplier_dashboard';
        var isInsightsPlatform = internal === 'insights_platform';
        var playerInsightsEnabled = !!((_user_organization = user.organization) === null || _user_organization === void 0 ? void 0 : _user_organization.can_developer_survey);
        var isBannedCustomer = customer && customer.insights_moderation_status === constants.INSIGHTS_MODERATION_STATUS_BANNED;
        var hasAccess = !!is_active && !isBannedCustomer;
        var isSupplier = !!supplier;
        var isCustomer = !!customer;
        var showPlayerInsightsActivation = !!hasAccess && !isInactivePublisher && !!(piActivation === null || piActivation === void 0 ? void 0 : piActivation.onOpen) && isSupplier && !isCustomer && !playerInsightsEnabled;
        var supplierRoutePrefix = isSupplierDashboard ? '' : '/supplier_dashboard';
        var insightsRoutePrefix = isInsightsPlatform ? '' : '/insights_platform';
        if (!hasAccess) return [];
        var hasSurveysAccess = !isInactivePublisher && (!!showPlayerInsightsActivation || isCustomer && !isBannedCustomer);
        var itemsArr = [];
        var isManaging = (user === null || user === void 0 ? void 0 : user.is_ops) && (user === null || user === void 0 ? void 0 : (_user_organization_membership = user.organization_membership) === null || _user_organization_membership === void 0 ? void 0 : _user_organization_membership.role) === 3; // ORGANIZATION_ROLE_CUSTOMER_SUCCESS
        var nav = {
            dashboard: {
                order: 1,
                icon: icons.tr.DashboardIcon,
                label: 'Dashboard',
                active: !!(isLinkActive === null || isLinkActive === void 0 ? void 0 : isLinkActive.dashboard),
                onClick: function() {
                    return onNavigate("".concat(supplierRoutePrefix, "/"), isSupplierDashboard);
                }
            },
            appTitles: {
                order: 2,
                icon: icons.io5.Apps,
                label: 'App titles',
                active: !!(isLinkActive === null || isLinkActive === void 0 ? void 0 : isLinkActive.appTitles),
                onClick: function() {
                    return onNavigate("".concat(supplierRoutePrefix, "/overview"), isSupplierDashboard);
                }
            },
            documentation: {
                order: 4,
                icon: icons.fi.Book,
                label: 'Documentation',
                active: !!(isLinkActive === null || isLinkActive === void 0 ? void 0 : isLinkActive.documentation),
                onClick: function() {
                    return onNavigate("".concat(supplierRoutePrefix, "/documentation"), isSupplierDashboard);
                }
            },
            surveys: {
                order: 3,
                icon: isSupplier ? icons.md.PersonSearch : icons.fi.Clipboard,
                label: isSupplier ? 'Player Insights' : 'Surveys',
                active: !!(isLinkActive === null || isLinkActive === void 0 ? void 0 : isLinkActive.surveys),
                onClick: function() {
                    return !!showPlayerInsightsActivation ? piActivation.onOpen() : onNavigate("".concat(insightsRoutePrefix, "/"), isInsightsPlatform);
                }
            }
        };
        if (isSupplier) {
            if (!isInactivePublisher) itemsArr.push(nav.dashboard, nav.appTitles);
            itemsArr.push(nav.documentation);
        }
        if (!!hasSurveysAccess) itemsArr.push(nav.surveys);
        return itemsArr.sort(function(a, b) {
            return a.order - b.order;
        });
    }, [
        props
    ]);
};
export var usePlayerInsightsActivation = function(param) {
    var user = param.user, _param_isInactivePublisher = param.isInactivePublisher, isInactivePublisher = _param_isInactivePublisher === void 0 ? false : _param_isInactivePublisher;
    var _user_organization_membership, _user_organization, _user_organization1, _user_organization2, _user_organization_membership1;
    var _useDisclosure = useDisclosure(), isOpen = _useDisclosure.isOpen, onOpen = _useDisclosure.onOpen, onClose = _useDisclosure.onClose;
    var isAdmin = (_user_organization_membership = user.organization_membership) === null || _user_organization_membership === void 0 ? void 0 : _user_organization_membership.is_admin;
    if (!user || !((_user_organization = user.organization) === null || _user_organization === void 0 ? void 0 : _user_organization.supplier) || !!((_user_organization1 = user.organization) === null || _user_organization1 === void 0 ? void 0 : _user_organization1.customer) || !!((_user_organization2 = user.organization) === null || _user_organization2 === void 0 ? void 0 : _user_organization2.can_developer_survey) || !((_user_organization_membership1 = user.organization_membership) === null || _user_organization_membership1 === void 0 ? void 0 : _user_organization_membership1.is_active) || isInactivePublisher) return null;
    var modal = /*#__PURE__*/ React.createElement(ActivatePlayerInsightsModal, {
        redirectLink: "/insights_platform/dashboard",
        isOpen: isOpen,
        onClose: onClose,
        isAdmin: isAdmin,
        orgIdentifier: user.organization.identifier
    });
    return {
        onOpen: onOpen,
        modal: modal
    };
};
export var useInactivePublisher = function(user) {
    return useMemo(function() {
        var _ref = user || {}, organization = _ref.organization, is_active = _ref.is_active;
        var supplier = (organization || {}).supplier;
        if (!supplier) return false;
        var status = supplier.status;
        return status != SUPPLIER_STATUS_ACTIVE || !is_active;
    }, [
        user
    ]);
};
